
<div>
  <div class="sr-only">
    <label for="allowDecimals">Allow Decimals</label>
  </div>
  <a-select
    v-model="allowDecimals"
    :options="allowDecimalsVOptions"
    id="allowDecimals"
    compress
    :disabled="disabled"
  ></a-select>
</div>
